import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as moment from "moment";

require('./bringoz-time-zone-display.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-time-zone-display',
  templateUrl: './bringoz-time-zone-display.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class BringozTimeZoneDisplayComponent implements OnInit, OnChanges {

  @Input() notBefore: any;
  @Input() notAfter: any;
  @Input() timeZoneId: string;
  @Input() configZoneId: string;
  @Input() isShowTime: boolean;
  @Input() isColumn: boolean;
  @Input() isSmall: boolean;

  public timeZoneOffsetDiff: number;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.checkTimeZoneOffsetDiff();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.notBefore && !changes.notBefore.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.notAfter && !changes.notAfter.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    const date = moment();

    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.notBefore || date);
    return this.timeZoneOffsetDiff !== 0;
  }

}
